import React from 'react';
import { useDispatch } from 'react-redux';

import analytics from '@ad-scripts/lib/analytics';
import Button from '@ad-scripts/presentation/components/common/button';
import OverflowMenu, {
  OverflowMenuButton,
  OverflowMenuItem,
  OverflowMenuLink,
  usePopoverMenu,
} from 'src/presentation/components/pages/shared/OverflowMenu';
import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';
import usersResource from 'src/actions/users/usersResource';
import { User, UserStatuses } from 'src/models/Users/User';
import { getUserStatus } from './helpers/usersHelper';

type UsersRowActionsType = {
  item: User;
  root: string;
};

const UsersRowActions = ({ root, item }: UsersRowActionsType): JSX.Element => {
  const dispatch = useDispatch();
  const { onClose, ...popoverMenuProps } = usePopoverMenu();
  const isFeatureEnabled = useIsFeatureEnabled();

  const handleResendInvite = () => {
    analytics.track('User - Resend activation token', {
      id: item.id,
    });
    dispatch(usersResource.effects.updateActivationToken({ userId: item.id }));
  };

  const userStatus = getUserStatus(item);
  const showResendInviteButton =
    !isFeatureEnabled('sso') &&
    [UserStatuses.INACTIVE, UserStatuses.INVITE_EXPIRED].includes(userStatus || UserStatuses.ACTIVE);

  return (
    <OverflowMenu id={item.id} onClose={onClose} {...popoverMenuProps}>
      {isFeatureEnabled('userManagement') && (
        <OverflowMenuItem id={`edit-${item.id}`}>
          <OverflowMenuLink to={location => ({ ...location, pathname: `${root}/${item.id}` })}>Edit</OverflowMenuLink>
        </OverflowMenuItem>
      )}
      {showResendInviteButton && (
        <OverflowMenuItem id={`resend-invite-${item.id}`}>
          <OverflowMenuButton data-aid={`resend-invite-${item.id}-button`} type={Button} onClick={handleResendInvite}>
            Resend invite
          </OverflowMenuButton>
        </OverflowMenuItem>
      )}
    </OverflowMenu>
  );
};

export default UsersRowActions;
